import React from "react";
import AdminAddSubCharacter from "../../Components/Admin/AdminAddSubCharacter";
import SideBar from "../../Components/Admin/SideBar";

const AdminAddSubCharacterPage = ()=>{
    return (
      <AdminAddSubCharacter />
    )
}

export default AdminAddSubCharacterPage;